module.exports = __webpack_public_path__ + "static/media/ic_pdf.4a8ca708.svg";